import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import Script from "next/script";
import { draftMode } from "next/headers";
import { PrismicPreviewClient } from "./PrismicPreviewClient.js";
import { getToolbarSrc } from './_node_modules/@prismicio/client/dist/getToolbarSrc.js';
function PrismicPreview({ repositoryName, children, ...props }) {
  const toolbarSrc = getToolbarSrc(repositoryName);
  let isDraftMode = false;
  try {
    isDraftMode = draftMode().isEnabled;
  } catch {
  }
  return jsxs(Fragment, { children: [children, jsx(PrismicPreviewClient, { repositoryName, isDraftMode, ...props }), jsx(Script, { src: toolbarSrc, strategy: "lazyOnload" })] });
}
export {
  PrismicPreview
};
//# sourceMappingURL=PrismicPreview.js.map
